import React, { useState, useEffect, useRef } from 'react';
import socketService from '../../services/socketService';
import './Chat.css';

// Obtener la URL base de la API de las variables de entorno
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000';

const ChatWindow = ({ currentUser, otherUser }) => {
  const [messages, setMessages] = useState([]);
  const [newMessage, setNewMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const messagesEndRef = useRef(null);
  
  // Cargar historial de mensajes al montar
  useEffect(() => {
    if (!currentUser || !otherUser) return;
    
    const loadChatHistory = async () => {
      try {
        setLoading(true);
        const roomId = [currentUser._id, otherUser._id].sort().join('-');
        const token = localStorage.getItem('token');
        
        const response = await fetch(`${API_URL}/api/messages/room/${roomId}`, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });
        
        if (response.ok) {
          const data = await response.json();
          setMessages(data.messages || []);
        }
      } catch (error) {
        console.error('Error al cargar mensajes:', error);
      } finally {
        setLoading(false);
      }
    };
    
    // Cargar mensajes
    loadChatHistory();
    
    // Unirse a sala de chat
    const roomId = socketService.joinChatRoom(currentUser._id, otherUser._id);
    
    // Escuchar nuevos mensajes
    socketService.on('message', (message) => {
      setMessages(prev => [...prev, message]);
    });
    
    return () => {
      // Limpiar listeners
      socketService.on('message', null);
    };
  }, [currentUser, otherUser]);
  
  // Scroll al último mensaje
  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages]);
  
  // Enviar mensaje
  const handleSendMessage = (e) => {
    e.preventDefault();
    
    if (!newMessage.trim()) return;
    
    // Enviar a través de WebSocket
    socketService.sendMessage(
      currentUser._id,
      otherUser._id,
      newMessage
    );
    
    // También guardar mediante API REST
    const saveMessage = async () => {
      try {
        const token = localStorage.getItem('token');
        await fetch(`${API_URL}/api/messages`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          },
          body: JSON.stringify({
            sender: currentUser._id,
            receiver: otherUser._id,
            message: newMessage
          })
        });
      } catch (error) {
        console.error('Error al guardar mensaje:', error);
      }
    };
    
    saveMessage();
    setNewMessage('');
  };
  
  if (loading) {
    return <div className="loading-chat">Cargando mensajes...</div>;
  }
  
  return (
    <div className="chat-window">
      <div className="chat-header">
        <h3>{otherUser.name}</h3>
      </div>
      
      <div className="messages-container">
        {messages.length === 0 ? (
          <div className="no-messages">
            <p>No hay mensajes aún. ¡Envía el primero!</p>
          </div>
        ) : (
          messages.map((msg, index) => (
            <div 
              key={index} 
              className={`message ${msg.sender === currentUser._id ? 'sent' : 'received'}`}
            >
              <div className="message-content">{msg.message}</div>
              <div className="message-time">
                {new Date(msg.sentAt || msg.timestamp).toLocaleTimeString()}
              </div>
            </div>
          ))
        )}
        <div ref={messagesEndRef} />
      </div>
      
      <form onSubmit={handleSendMessage} className="message-form">
        <input
          type="text"
          value={newMessage}
          onChange={(e) => setNewMessage(e.target.value)}
          placeholder="Escribe un mensaje..."
        />
        <button type="submit">Enviar</button>
      </form>
    </div>
  );
};

export default ChatWindow; 